export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'orderNo',
    title: '订单编号',
    align: 'center',
    fixed: 'left',
    width: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'orderType',
    align: 'center',
    width: 150,
    title: '订单类型',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'bizType',
    align: 'center',
    width: 150,
    title: '业务类型',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'transportMode',
    align: 'center',
    width: 150,
    title: '运输模式',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'vehicleModelDesc',
    align: 'center',
    width: 150,
    title: '车辆说明',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'vehicleTotalQty',
    align: 'center',
    width: 150,
    title: '车辆总数量',
    sortType: 'number',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'carrierDesc',
    align: 'center',
    width: 150,
    title: '承运商说明',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'vehicleNoDesc',
    align: 'center',
    width: 150,
    title: '车牌号说明',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originProvinceName',
    align: 'center',
    width: 150,
    title: '始发地省份名称',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originCityName',
    align: 'center',
    width: 150,
    title: '始发地城市名称',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originDistrictName',
    align: 'center',
    width: 150,
    title: '始发地区县名称',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originPlace',
    align: 'center',
    width: 150,
    title: '始发地园区',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originLongitude',
    align: 'center',
    width: 150,
    title: '始发地经度',
    sortType: 'string',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',

  },
  {
    field: 'originLatitude',
    align: 'center',
    width: 150,
    title: '始发地纬度',
    sortType: 'string',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',

  },
  {
    field: 'pickDateTime',
    align: 'center',
    width: 200,
    title: '始发地发货方名称',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'destinationProvinceName',
    align: 'center',
    width: 150,
    title: '目的地省份名称',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'destinationCityName',
    align: 'center',
    width: 150,
    title: '目的地城市名称',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'destinationDistrictName',
    align: 'center',
    width: 150,
    title: '目的地区县名称',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'destinationPlace',
    align: 'center',
    width: 150,
    title: '目的地园区',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'destinationLongitude',
    align: 'center',
    width: 150,
    title: '地图经度',
    sortType: 'string',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',

  },
  {
    field: 'destinationLatitude',
    align: 'center',
    width: 150,
    title: '地图纬度',
    sortType: 'string',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',

  },
  {
    field: 'destinationName',
    align: 'center',
    width: 150,
    title: '目的地收货方名称',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'receiveDateTime',
    align: 'center',
    width: 160,
    title: '实际到货时间',
    sortType: 'string',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',

  },
  {
    field: 'goodsName',
    align: 'center',
    width: 150,
    title: '货物名称合集',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',

  },
  {
    field: 'goodsQty',
    align: 'center',
    width: 150,
    title: '总件数',
    sortType: 'number',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',

  },
  {
    field: 'goodsWeight',
    align: 'center',
    width: 150,
    title: '预计总重量',
    sortType: 'number',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',

  },
  {
    field: 'goodsVolume',
    align: 'center',
    width: 150,
    title: '预计总体积',
    sortType: 'number',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',

  },
  {
    field: 'goodsValue',
    align: 'center',
    width: 150,
    title: '总货值',
    sortType: 'number',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',

  },
  {
    field: 'factWeight',
    align: 'center',
    width: 150,
    title: '实际总重量',
    sortType: 'number',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',

  },
  {
    field: 'factVolume',
    align: 'center',
    width: 150,
    title: '实际总体积',
    sortType: 'number',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',

  },
  {
    field: 'incomeAmount',
    align: 'center',
    width: 150,
    title: '应收运费合计',
    sortType: 'number',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'incomeCostAmount',
    align: 'center',
    width: 150,
    title: '应收费用合计',
    sortType: 'number',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    slots: {
      default: 'incomeCostAmount',
    },
  },
  {
    field: 'incomeTotalAmount',
    align: 'center',
    width: 150,
    title: '应收合计',
    sortType: 'number',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',

  },
  {
    field: 'wayBillPodDateTime',
    align: 'center',
    width: 160,
    title: '运单回单时间',
    sortType: 'string',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',

  },
]
